import React, { createContext, useState, useContext, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

// 创建上下文
const ZoneContext = createContext();

// 上下文提供者组件
export const ZoneProvider = ({ children }) => {
  // 创建状态存储当前区域
  // 安全地获取 localStorage 中的区域设置
  const getInitialZone = () => {
    try {
      return localStorage.getItem('currentZone') || 'beijing';
    } catch (e) {
      console.warn('无法访问 localStorage，使用默认区域:', e);
      return 'beijing';
    }
  };
  
  const [currentZone, setCurrentZone] = useState(getInitialZone);
  const params = useParams();
  const location = useLocation();

  // 当路由参数中的区域变化时更新当前区域
  useEffect(() => {
    if (params.zone && params.zone !== currentZone) {
      setCurrentZone(params.zone);
      // 保存到本地存储，以便在页面刷新后保持
      try {
        localStorage.setItem('currentZone', params.zone);
        console.log('区域已更新:', params.zone);
      } catch (e) {
        console.warn('无法保存区域到 localStorage:', e);
      }
    }
  }, [params.zone, location.pathname]);

  // 提供更新区域的方法
  const updateZone = (newZone) => {
    if (newZone && newZone !== currentZone) {
      setCurrentZone(newZone);
      try {
        localStorage.setItem('currentZone', newZone);
        console.log('区域已手动更新:', newZone);
      } catch (e) {
        console.warn('无法保存区域到 localStorage:', e);
      }
    }
  };

  return (
    <ZoneContext.Provider 
      value={{ 
        currentZone, 
        updateZone 
      }}
    >
      {children}
    </ZoneContext.Provider>
  );
};

// 创建自定义钩子以便轻松使用上下文
export const useZone = () => {
  const context = useContext(ZoneContext);
  if (!context) {
    throw new Error('useZone 必须在 ZoneProvider 内部使用');
  }
  return context;
};

export default ZoneContext; 